import React, { Component } from "react"
import styled from "styled-components"
import Slider from "react-slick"
import parse from "html-react-parser"
import { GatsbyImage } from "gatsby-plugin-image"
import Arrow from ".././../assets/slider-arrow.inline.svg"
import Button from "../global/Button"
import RellaxWrapper from "react-rellax-wrapper"
import { BsArrowDown } from "react-icons/bs"

import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"

const BlogFeaturedSliderWrapper = styled.section`
  width: 100%;
  position: relative;
  overflow: hidden;

  @media only screen and (min-width: 1024px) {
    background: var(--black);
    min-height: 750px;
    height: calc(100vh - var(--headerHeight));
    height: calc((var(--vh, 1vh) * 100 - var(--headerHeight)));
  }

  .scroller {
    position: absolute;
    right: 1rem;
    bottom: 2rem;
    color: var(--black);
    z-index: 10;
    writing-mode: vertical-rl;
    text-orientation: mixed;
    display: flex;
    align-items: center;
    justify-content: center;
    animation: slide-bottom 0.75s cubic-bezier(0.895, 0.03, 0.685, 0.22)
      infinite alternate both;
    display: none;

    @media only screen and (min-width: 1024px) {
      display: block;
    }

    span {
      margin-bottom: 1rem;
      font-family: var(--font-heading);
      text-transform: uppercase;
      font-size: 1.4rem;
    }
    svg {
      font-size: 2rem;
    }
  }

  .slider {
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    &:before {
      width: 100%;
      height: 80%;
      position: absolute;
      bottom: 0;
      left: 0;
      content: "";
      background: var(--brandColor);
    }

    @media only screen and (min-width: 1024px) {
      position: absolute;
      background: var(--brandColor);
    }

    .slick-list,
    .slick-track {
      height: 100% !important;
    }

    .left {
      position: relative;
      width: 100%;
      min-height: 40vh;

      @media only screen and (min-width: 1024px) {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 60%;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        flex-direction: column;
        padding: 0 4rem;
      }

      .image-wrapper {
        width: 100%;
        height: 100%;
        position: absolute;
        bottom: 0;
        left: 0;
        z-index: 0;

        .gatsby-image-wrapper {
          position: absolute;
          width: 100%;
          height: 120%;

          @media only screen and (min-width: 1024px) {
            height: 110%;
          }

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }
    }

    .right {
      position: relative;
      width: 100%;
      min-height: 40vh;
      padding: 2rem;
      z-index: 10;
      background: var(--brandColor);

      @media only screen and (min-width: 1024px) {
        width: 40%;
        height: 100%;
        padding: 0;
        position: absolute;
        top: 0;
        right: 0;
        padding: 0 4rem;
        display: flex;
        flex-wrap: wrap;
        /* align-items:center; */
        justify-content: center;
        flex-direction: column;
      }

      .heading--l {
        color: var(--black);
        z-index: 1;
        position: relative;
        margin-bottom: 2rem;
      }

      .text {
        font-family: var(--font-reg);
        color: var(--black);
        z-index: 1;
        position: relative;
        max-width: 480px;
        margin-bottom: 4rem;
        width: 100%;
        font-size: 0.9rem;

        p {
          line-height: 1.5rem;
        }
      }

      .button {
        flex-basis: 0 0 0 0;
      }
    }
  }
`

const SliderArrows = styled.div`
  position: absolute;
  bottom: 2rem;
  right: 2rem;
  z-index: 25;

  @media only screen and (min-width: 1024px) {
    top: 2rem;
    bottom: initial;
  }

  .arrow {
    cursor: pointer;
    transition: 0.5s all ease-in-out;

    &.inactive {
      cursor: default;
      pointer-events: none;
      opacity: 0.3;
    }
  }

  .prev {
    transform: rotate(180deg);
    margin-right: 2rem;
  }
`

export default class BlogFeaturedSlider extends Component {
  state = {
    slideIndex: 0,
    updateCount: 0,
  }
  render() {
    const sliderPosts = this.props.slider
    const postCat = this.props.postCat

    const wrapperStyles = {
      height: "100%",
      width: "100%",
      position: "absolute",
      top: "0",
      left: "0",
    }

    return (
      <BlogFeaturedSliderWrapper className={this.props.className}>
        <div className="scroller">
          <span>Scroll</span> <BsArrowDown />
        </div>
        <SliderArrows>
          <Arrow
            className="prev arrow"
            onClick={e => this.slider.slickPrev()}
          />
          <Arrow
            className="next arrow"
            onClick={e => this.slider.slickNext()}
          />
        </SliderArrows>
        <Slider
          ref={slider => (this.slider = slider)}
          dots={false}
          infinite={true}
          fade={true}
          speed={500}
          arrows={false}
          slidesToShow={1}
          autoplay={true}
          slidesToScroll={1}
          className="slider"
          adaptiveHeight={true}
        >
          {sliderPosts.map((item, index) => {
            return (
              <div className="slide" key={item?.post?.title + index}>
                <div className="left">
                  <div className="image-wrapper">
                    <RellaxWrapper
                      zIndex={1}
                      desktop={-1.25}
                      style={wrapperStyles}
                      mobile={1.25}
                      tablet={1.25}
                      breakpoints={[500, 1024, 1201]}
                      center={true}
                    >
                      <GatsbyImage
                        image={
                          item?.post?.acf_customFeaturedImage?.featuredImage
                            ?.localFile?.childImageSharp?.gatsbyImageData
                        }
                      />
                    </RellaxWrapper>
                  </div>
                </div>
                <div className="right">
                  <div className="heading--l">{item?.post?.title}</div>
                  <div className="text">{parse(item?.post?.excerpt)}</div>
                  <Button
                    color="black"
                    bg="black"
                    text={"Read more"}
                    link={postCat + item?.post?.link}
                  />
                </div>
              </div>
            )
          })}
        </Slider>
      </BlogFeaturedSliderWrapper>
    )
  }
}
